import * as moment from 'moment';
import { DateTimeConverter } from 'src/app/core/services/mapper/converters';
import { ArrayClassConverterFactory } from '../../../core/services/mapper/data-property.converter';

export class DetailsObjetFacture {
    static jsonMap = {
        id: { key: 'id', optional: true },
        idToSend: { key: 'idToSend', converter: new (ArrayClassConverterFactory.build(Number))(), optional: true },
        dateFacturation: { key: 'dateFacturation', converter: new DateTimeConverter(), optional: true },
        mailOperateur: { key: 'mailOperateur', optional: true, default: '' },
        montantTva: { key: 'montantTva', optional: true },
        prixMini: { key: 'prixMini', optional: true },
        prixUnitaire: { key: 'prixUnitaire', optional: true },
        quantite: { key: 'quantite', optional: true },
        totalHt: { key: 'totalHt', optional: true },
        totalTtc: { key: 'totalTtc', optional: true },
        tva: { key: 'tva', optional: true },
        idIntervenant: { key: 'idIntervenant', optional: true },
        libelleModeleArticle: { key: 'libelleModeleArticle', optional: true, default: '' },
        idObjetFactures: { key: 'idObjetFactures', converter: new (ArrayClassConverterFactory.build(Number))(), optional: true },
        idRefQuantiteFacture: { key: 'idRefQuantiteFacture', optional: true }
    };

    id: number;
    idToSend: number[];
    dateFacturation: moment.Moment;
    mailOperateur: string;
    montantTva: number;
    prixMini: number;
    prixUnitaire: number;
    quantite: number;
    totalHt: number;
    totalTtc: number;
    tva: number;
    idIntervenant: number;
    libelleModeleArticle: string;
    idObjetFactures: number[];
    idRefQuantiteFacture: number;
}
